// src/components/Leaderboard.js

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './Leaderboard.css';

const Leaderboard = ({ campaignID }) => {
  const [leaderboard, setLeaderboard] = useState([]);
  const [campaignName, setCampaignName] = useState('');
  const [campaignImage, setCampaignImage] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (campaignID) {
      setLoading(true);
      setError(false);

      axios
        .get(`/api/campaigns/details`, {
          params: {
            campaign_id: campaignID,
          },
        })
        .then((response) => {
          setLeaderboard(response.data.leaderboard);
          setCampaignName(response.data.campaignName || '');
          setCampaignImage(response.data.campaignImage || '');
          setLoading(false);
        })
        .catch((error) => {
          console.error('Error fetching leaderboard data:', error);
          setError(true);
          setLoading(false);
        });
    }
  }, [campaignID]);

  if (loading) {
    return <p className="text-center">Loading leaderboard...</p>;
  }

  if (error) {
    return (
      <p className="text-center text-red-500">
        Failed to load leaderboard data.
      </p>
    );
  }

  // Inline style for background image
  const headerStyle = {
    backgroundImage: `url(${campaignImage}), linear-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0.5))`,
    
  };

  return (
    <main className="leaderboard-main">
      <div
        id="header"
        className="leaderboard-header"
        style={campaignImage ? headerStyle : {}}
      >
        <h1>{campaignName || 'Ranking'}</h1>
        {/* The 'Share' button has been removed */}
      </div>
      <div id="leaderboard" className="leaderboard-section">
        <div className="ribbon"></div>
        <table>
          <tbody>
            {leaderboard.slice(0, 5).map((player, index) => (
              <tr key={player.player_id}>
                <td className="number">{index + 1}</td>
                <td className="name">{player.player_username}</td>
                <td className="points">
                  {player.score}
                  {index === 0 && (
                    <img
                      className="gold-medal"
                      src="/images/gold-medal.png"
                      alt="Gold Medal"
                    />
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {/* The 'Exit' and 'Continue' buttons have been removed */}
      </div>
    </main>
  );
};

export default Leaderboard;
